(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
  function setCollectionCanvasHeight() {
    const container = document.querySelector('.collection-container');
    const firstProductCard = container && container.querySelector('[data-product-card]');
    if (!firstProductCard) return;

    const canvas = firstProductCard.querySelector('img');
    if (!canvas) return;

    const section = container.closest('.shopify-section');
    if (!section) return;

    section.style.setProperty('--product-card-canvas-height', canvas.offsetHeight + 'px');
  }

  document.addEventListener('DOMContentLoaded', setCollectionCanvasHeight);
  window.addEventListener('resize', setCollectionCanvasHeight);

  } catch(e) { console.error(e); }
})();
})();
